import { HelpCenterController } from './helpcenter-controller';
import { KnowledgeBaseController } from 'controllers/knowledge-base-controller';

export const controllers = [HelpCenterController, KnowledgeBaseController];
